var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
const claim = namespace('claim');
const qualification = namespace('qualification');
let IsResponsibleForDamagesToOthersQuestion = class IsResponsibleForDamagesToOthersQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    updateClaim(isResponsibleForDamagesToOthers) {
        this.updateAndSaveQualification({
            qualificationPayload: { isResponsibleForDamagesToOthers },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.responsible_of_damages_to_others.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.responsible_of_damages_to_others.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.isResponsibleForDamagesToOthers === null) {
            return null;
        }
        return this.qualification.isResponsibleForDamagesToOthers
            ? this.$tc('claim.qualification.is_responsible.damages.to.others.sumup.yes')
            : this.$tc('claim.qualification.is_responsible.damages.to.others.sumup.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], IsResponsibleForDamagesToOthersQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], IsResponsibleForDamagesToOthersQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], IsResponsibleForDamagesToOthersQuestion.prototype, "updateAndSaveQualification", void 0);
IsResponsibleForDamagesToOthersQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], IsResponsibleForDamagesToOthersQuestion);
export default IsResponsibleForDamagesToOthersQuestion;
